<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item">
        <router-link to="/sale/invoices">{{ $t("sale_invoice_list") }}</router-link>
      </li>
      <li class="breadcrumb-item active" aria-current="page">[{{ invoice.Num }}]</li>
    </ol>
    <div class="x_header">
      <button
        type="button"
        class="btn btn-outline-primary btn-sm no-bor"
        @click="$router.go(-1)"
      >
        <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t("back") }}
      </button>
      <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
        <i class="fa fa-print"></i> {{ $t("print") }}
      </button>
      <template>
        <router-link
          v-if="invoice.Balance != 0"
          :to="{ name: 'sale_invoice_update', params: { id: $route.params.id } }"
          class="btn btn-outline-primary btn-sm no-bor"
          ><i class="fa fa-pencil"></i> {{ $t("edit") }}</router-link
        >
        <button 
          v-if="invoice.PaidStatus == 'Not Paid'"
          type="button"
          class="btn btn-outline-danger btn-sm no-bor"
          @click="confirmDelete"
        >
          <i class="fa fa-times"></i> {{ $t("delete") }}
        </button>
      </template>
    </div>
    <div class="x_body">
      <div class="card f_card">
        <div class="card-body">
          <div class="print-header">
            <h6 class="text-center font-m">វិក្កយបត្រ</h6>
            <h6 class="text-center" style="font-weight: 600">
              {{ invoice.InvoiceType }} INVOICE
            </h6>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <table class="table-sm" style="border: 1px solid #ddd; width: 100%">
                <thead>
                  <tr style="border-bottom: 1px solid #ddd">
                    <th colspan="3">អតិថិជន/Customer Name</th>
                    <th colspan="3"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="vertical-align: top">
                    <td style="width: 130px">
                      អតិថិជន<br /><span style="font-size: 12px">NAME</span>
                    </td>
                    <td class="v-top" style="width: 15px">:</td>
                    <td class="v-top" style="border-right: 1px solid #ddd">
                      {{ customer.Name }}<br />{{ customer.NameEng }}
                    </td>
                    <td style="width: 105px">
                      លេខវិក្កយបត្រ<br /><span style="font-size: 12px">INVOICE NO</span>
                    </td>
                    <td style="width: 15px">:</td>
                    <td style="width: 180px">{{ invoice.Num }}</td>
                  </tr>
                  <tr style="vertical-align: top">
                    <td>អាស័យដ្ឋាន<br /><span style="font-size: 12px">ADDRESS</span></td>
                    <td>:</td>
                    <td style="border-right: 1px solid #ddd">{{ customer.Address }}</td>
                    <td>កាលបរិច្ឆេទ<br /><span style="font-size: 12px">DATE</span></td>
                    <td>:</td>
                    <td>{{ $format(invoice.Date, "DD/MM/YYYY") }}</td>
                  </tr>
                  <tr style="v-top">
                    <td>លេខទូរស័ព្ទ</td>
                    <td>:</td>
                    <td style="border-right: 1px solid #ddd">{{ customer.Phone }}</td>
                    <td>អត្រាប្ដូរប្រាក់</td>
                    <td>:</td>
                    <td>{{ invoice.ExchangeRate }}</td>
                  </tr>
                  <tr class="v-top">
                    <td>លេខអ.ត.ប​(VAT-TIN)</td>
                    <td>:</td>
                    <td style="border-right: 1px solid #ddd">
                      {{ customer.TinHead }}-{{ customer.VatTin }}
                    </td>
                    <td>ផុតកំណត់<br /><span style="font-size: 12px">DUE DATE</span></td>
                    <td>:</td>
                    <td>{{ $format(invoice.DueDate, "DD/MM/YYYY") }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12">
              <table class="table table-bordered table-sm no-bor">
                <thead class="table-primary">
                  <tr>
                    <th class="text-center" style="width: 50px">
                      ល.រ <br />
                      NO
                    </th>
                    <th class="text-center">លេខកូដ<br />CODE</th>
                    <th class="text-center">
                      បរិយាយមុខទំនិញ ឬសេវាកម្ម <br />
                      DESCRIPTION OF GOODS OR SERVICES
                    </th>
                    <th class="text-center" style="width: 100px">
                      បរិមាណ <br />
                      QTY
                    </th>
                    <th class="text-center" style="width: 100px">
                      {{ $t("uom") }}<br />UNIT
                    </th>
                    <th class="text-center" style="width: 100px">
                      តម្លៃឯកតា <br />
                      PRICE
                    </th>
                    <th class="text-center" style="width: 100px">អ.ត.ប<br />VAT</th>
                    <th class="text-center" style="width: 100px">
                      ថ្លៃទំនិញ <br />
                      AMOUNT
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ret, index) in lines" :key="ret.Id">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ ret.ItemCode }}</td>
                    <td>{{ ret.Description }}</td>
                    <td class="text-center">{{ ret.Quantity }}</td>
                    <td class="text-center">{{ ret.UomName }}</td>
                    <td class="text-right">{{ $money(ret.Price) }}</td>
                    <td class="text-right">{{ $money(ret.TaxAmount) }}</td>
                    <td class="text-right">{{ $money(ret.SubTotal) }}</td>
                  </tr>
                </tbody>
                <tfoot class="table-active">
                  <tr>
                    <td colspan="7" class="text-right">សរុប / Total:</td>
                    <td style="width: 120px" class="text-right">
                      {{ $dollar(invoice.GrandTotal) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7" class="text-right">អាករលើតម្លៃបន្ថែម VAT (10%):</td>
                    <td style="width: 120px" class="text-right">
                      {{ $dollar(invoice.TaxVat) }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7" style="width: 150px" class="text-right">
                      សរុបរួម​/ Grand Total:
                    </td>
                    <td class="text-right">{{ $dollar(invoice.TotalAmount) }}</td>
                  </tr>
                  <tr>
                    <td colspan="7" class="text-right">ចំនួនទឹកប្រាក់ជាលុយរៀល:</td>
                    <td class="text-right">
                      R {{ $number(invoice.TotalAmount * invoice.ExchangeRate) }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group" style="display: flex">
                <label class="control-lable" style="margin-right: 10px"
                  >{{ $t("noted") }}:
                </label>
                <div>{{ invoice.Description }}</div>
              </div>
            </div>
          </div>
          <div class="row" v-if="invoice.Status != 'Draft'">
            <div class="col-sm-12">
              <br />
              <p class="blue" style="font-weight: bold; margin-bottom: 3px">
                <i class="fa fa-car" aria-hidden="true"></i> {{ $t("stock_out") }}
              </p>
              <table class="table table-bordered table-sm table-striped no-bor">
                <thead>
                  <tr>
                    <th style="width: 50px" class="text-center">{{ $t("no") }}</th>
                    <th>{{ $t("code") }}</th>
                    <th>{{ $t("date") }}</th>
                    <th>{{ $t("type") }}</th>
                    <th>{{ $t("ref_num") }}</th>
                    <th>{{ $t("branch") }}</th>
                    <th>{{ $t("requestor") }}</th>
                    <th>{{ $t("customer") }}</th>
                    <th style="width: 80px">{{ $t("status") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ret, index) in stockouts" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link
                        :to="{ name: 'stock_out_preview', params: { id: ret.Id } }"
                        >{{ ret.Num }}</router-link
                      >
                    </td>
                    <td>{{ $format(ret.OutDateAt, "DD-MM-YYYY") }}</td>
                    <td>{{ ret.DocSource }}</td>
                    <td>{{ ret.DocSourceNo }}</td>
                    <td>{{ ret.BranchName }}</td>
                    <td>{{ ret.TakerOut }}</td>
                    <td>{{ ret.CustomerName }}</td>
                    <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row" v-if="invoice.Status != 'Draft'">
            <div class="col-sm-12">
              <br />
              <p class="blue" style="font-weight: bold; margin-bottom: 3px">
                <i class="fa fa-usd" aria-hidden="true"></i> {{ $t("sale_receipt") }}
              </p>
              <table class="table table-bordered table-striped table-sm no-bor">
                <thead>
                  <tr>
                    <th style="width: 50px">{{ $t("no") }}</th>
                    <th>{{ $t("code") }}</th>
                    <th>{{ $t("date") }}</th>
                    <th>{{ $t("payment_method") }}</th>
                    <th>{{ $t("description") }}</th>
                    <th>{{ $t("ref_num") }}</th>
                    <th>{{ $t("amount") }}</th>
                    <th style="width: 80px">{{ $t("status") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ret, index) in receipts" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <router-link
                        :to="{ name: 'sale_receipt_preview', params: { id: ret.Id } }"
                        >{{ ret.Num }}</router-link
                      >
                    </td>
                    <td>{{ $format(ret.Date, "DD/MM/YYYY") }}</td>
                    <td>{{ ret.AccountName }}</td>
                    <td>{{ ret.Description }}</td>
                    <td>{{ ret.DocSourceNo }}</td>
                    <td class="text-right">{{ $money(ret.Amount) }}</td>
                    <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sale from "../../../shared/models/Sale";
import PdfSale from './Prints/AdvTaxInvoice';
export default {
  data: function () {
    return {
      invoice: {},
      lines: [],
      customer: {},
      stockouts: [],
      receipts: [],
    };
  },
  created: function () {
    let id = this.$route.params.id;
    if (id != undefined && id != null && id != "") {
      this.findById(id);
      Sale.getStockoutFromInvoice({ Id: id }).then((res) => {
        this.stockouts = res.Json.Stockouts;
      });
      Sale.getReceiptFromInvoice({ Id: id }).then((res) => {
        this.receipts = res.Json.Receipts;
      });
    }
  },
  methods: {
    findById(id) {
      let loading = this.$loading.show();
      let req = {
        CompanyId: this.$store.state.company.Id,
        Id: id,
      };
      Sale.findInvoicePreview(req)
        .then((res) => {
          this.invoice = res.Json.Header;
          this.lines = res.Json.Lines;
          this.customer = res.Json.Customer;
        })
        .finally(() => {
          loading.hide();
        });
    },
    print() {
      
      if(this.invoice.InvoiceType == 'AVDTAX'){
        PdfSale.print();
      }else{
        let type = this.invoice.InvoiceType == "TAX" ? "taxinvoice" : "nontaxinvoice";
        window.open("/print/" + type + "/" + this.invoice.Id, "_blank");
      }
      
    },
    onApproval() {
      let id = this.$route.params.id;
      let loading = this.$loading.show();
      this.$api()
        .post("invoice/approval", { Id: id })
        .then((res) => {
          if (this.$isValid(res)) {
            this.$router.go(-1);
          }
        })
        .finally(function () {
          loading.hide();
        });
    },
    confirmDelete() {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        })
        .then((result) => {
          if (result.value) {
            this.deleteById();
          }
        });
    },
    deleteById() {
      let id = this.$route.params.id;
      let loading = this.$loading.show();
      this.$api()
        .post("invoice/cancel", { Id: id })
        .then((res) => {
          if (this.$isValid(res)) {
            this.$router.go(-1);
          }
        })
        .finally(function () {
          loading.hide();
        });
    },
  },
  computed: {
    isCompleted() {
      var res = true;
      for (var i = 0; i < this.lines.length; i++) {
        var item = this.lines[i];
        if (item.Quantity > item.StockoutQty) {
          res = false;
          break;
        }
      }
      return res;
    },
    deliveryDate() {
      var res = "N/A";
      if (this.invoice.DocSource == "Manual" && this.invoice.DeliveryNote != null) {
        res = this.$format(this.invoice.DeliveryNote.OutDateAt, "DD/MM/YYYY");
      } else res = this.invoice.DeliveryDateNote;
      return res;
    },
    deliveryNo() {
      var res = "N/A";
      if (this.invoice.DocSource == "Manual" && this.invoice.DeliveryNote != null) {
        res = this.invoice.DeliveryNote.Num;
      }

      return res;
    },
  },
};
</script>
<style scoped>
label {
  margin-bottom: 0;
}
</style>
